<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Nueva orden de ingreso</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <div class="vx-row">
          <!--Number-->
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <vs-input @blur="output.number= trimString(output.number)" label="Número de orden*" v-model="output.number"
                      class="w-full" name="name"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <!--Reception date-->
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="vs-select--label" for="dateIssue">Fecha de emisión*</label>
            <datepicker label="Fecha de emisión" v-model="output.dateIssue"
                        id="dateIssue" v-validate="'required'" name="dateIssue"></datepicker>
            <span class="text-danger text-sm"
                  v-show="errors.has('dateIssue')">{{ errors.first('dateIssue') }}</span>
          </div>
          <!--Date of transfer-->
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="vs-select--label" for="dateIssue">Fecha de traslado*</label>
            <datepicker label="Fecha de traslado" v-model="output.dateOfTransfer"
                        id="dateOfTransfer" v-validate="'required'" name="dateOfTransfer"></datepicker>
            <span class="text-danger text-sm"
                  v-show="errors.has('dateOfTransfer')">{{ errors.first('dateOfTransfer') }}</span>
          </div>
          <!-- State-->
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="text-sm opacity-75">Estado</label>
            <v-select :options="statesText" :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="output.stateText" class="mb-4 md:mb-0" name="stateText" v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('stateText')">{{ errors.first('stateText') }}</span>
          </div>
        </div>
        <div class="mt-5">
          <!-- Client-->
          <label class="text-sm opacity-75">Cliente</label>
          <v-select label="name" :options="clients" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="output.client" class="mb-4 md:mb-0" name="client" v-validate="'required'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('client')">{{ errors.first('client') }}</span>
        </div>
        <div class="mt-5">
          <!-- Destination-->
          <vs-input @blur="output.destination= trimString(output.destination)" label="Destino*"
                    v-model="output.destination"
                    class="w-full" name="destination"
                    v-validate="'required'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('destination')">{{ errors.first('destination') }}</span>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
            <!-- Vehicle -->
            <vs-input @blur="output.vehicle= trimString(output.vehicle)" label="Vehículo marca y placa Nº*"
                      v-model="output.vehicle"
                      class="w-full" name="vehicle"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('vehicle')">{{ errors.first('vehicle') }}</span>
          </div>
          <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
            <!-- Certificate -->
            <vs-input @blur="output.certificate= trimString(output.certificate)" label="Certificado de inscripción Nº*"
                      v-model="output.certificate"
                      class="w-full" name="certificate"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('certificate')">{{ errors.first('certificate') }}</span>
          </div>
          <div class="vx-col w-1/3 md:w-1/3 xl:w-1/3">
            <!-- Driver's license -->
            <vs-input @blur="output.license= trimString(output.license)" label="Licencia de conducir*"
                      v-model="output.license"
                      class="w-full" name="license"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('license')">{{ errors.first('license') }}</span>
          </div>
        </div>
        <hr class="mt-5 mb-5">
        <div class="vx-row">
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="text-sm opacity-75">Selecciona Marca</label>
            <v-select @input="loadCategoryBrands" label="name" :options="brands" :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="selectedBrand" class="mb-4 md:mb-0" name="brand" v-validate="'required'"/>
          </div>
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="text-sm opacity-75">Selecciona Categoría</label>
            <v-select @input="loadProducts" label="name" :options="brandsCategories" :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="selectedCategory" class="mb-4 md:mb-0" name="brand" v-validate="'required'"/>
          </div>
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <label class="text-sm opacity-75">Selecciona producto</label>
            <v-select label="name" :options="products" :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="newProduct" class="mb-4 md:mb-0" name="brand" v-validate="'required'"/>
          </div>
          <div class="vx-col w-1/4 md:w-1/4 xl:w-1/4">
            <vs-input type="number" label="Cantidad*" v-model.number="newProduct.quantity"
                      class="w-full" name="quantity"/>
          </div>
        </div>
        <div class="mt-5">
          <vs-button @click="addProduct" style="width: 100%">Agregar producto</vs-button>
        </div>
        <div class="mt-5">
          <vs-table class="mt-5" :data="output.products">
            <template slot="thead">
              <vs-th sort-key="sku">Código</vs-th>
              <vs-th sort-key="name">Nombre</vs-th>
              <vs-th sort-key="brand">Marca</vs-th>
              <vs-th sort-key="category">Categoría</vs-th>
              <vs-th sort-key="quantity">Cantidad</vs-th>
              <vs-th sort-key="delete">Eliminar</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.sku">
                  {{ tr.sku }}
                </vs-td>

                <vs-td :data="tr.name">
                  {{ tr.name }}
                </vs-td>

                <vs-td :data="tr.brand">
                  {{ tr.brand.name }}
                </vs-td>

                <vs-td :data="tr.category">
                  {{ tr.category.name }}
                </vs-td>

                <vs-td :data="tr.quantity">
                  <template>
                    <vs-input type="number" min="0" v-model.number="tr.quantity"/>
                  </template>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon class="ml-2" icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click.stop="deleteProduct(tr,indextr)"/>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from "../../mixins/trimString"
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

const firebase = require("firebase")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()
export default {
  name: 'UpdateOutput',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
    clients: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    Datepicker
  },
  mixins: [trimString],
  data() {
    return {
      output: {
        products: []
      },
      newProduct: {},
      brandsCategories: [],
      products: [],
      selectedBrand: {},
      selectedCategory: {},

      statesText: [
        {label: 'En borrador', value: 'draft'},
        {label: 'Publicada', value: 'published'}
      ],

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false
    }
  },
  watch: {
    async isSidebarActive(val) {
      if (!val) return
      this.output = {
        ...this.data
      }
      this.$validator.reset()
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    submitData() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.progress = true
          const docRef = db.collection('outputs').doc(this.output.id)
          // Update output
          docRef.update({
            ...this.output,
            uid: firebase.auth().currentUser.uid,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
          }).then(() => {
            let obj = {
              ...this.output
            }
            this.$store.dispatch('outputs/updateOutput', {output: obj})
            this.progress = false
            this.$vs.notify({
              color: 'success',
              title: 'Salida',
              text: 'Salida modificada correctamente.'
            })
            this.$emit('closeSidebar')
          }).catch(() => {
            this.progress = false
            this.$vs.notify({
              color: 'warning',
              title: '¡Oh no!',
              text: 'Hubo un error.'
            })
          })
        }
      })
    },
    initValues() {
      this.output = {
        products: []
      }
      this.newProduct = {
        quantity: 0
      }
      this.selectedCategory = {}
      this.selectedBrand = {}
    },
    async loadCategoryBrands() {
      try {
        if (this.selectedBrand.id) {
          this.brandsCategories = []
          const querySnap = await db.collection('categories').where('brand.id', '==', this.selectedBrand.id).get()
          querySnap.forEach((doc) => {
            const obj = {
              id: doc.id,
              ...doc.data()
            }
            this.brandsCategories.push(obj)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    async loadProducts() {
      try {
        if (this.selectedCategory.id) {
          this.products = []
          const querySnap = await db.collection('products')
              .where('category.id', '==', this.selectedCategory.id)
              .where('state', '==', true).get()
          querySnap.forEach((doc) => {
            const obj = {
              id: doc.id,
              ...doc.data(),
              quantity: 0
            }
            this.products.push(obj)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    deleteProduct(index) {
      this.output.products.slice(index, 1)
    },
    addProduct() {
      if (this.newProduct.id && this.newProduct.quantity !== 0) {
        const productIndex = this.output.products.findIndex((p) => p.id === this.newProduct.id)
        if (productIndex === -1) {
          const obj = {
            id: this.newProduct.id,
            name: this.newProduct.name,
            brand: this.newProduct.brand,
            category: this.newProduct.category,
            sku: this.newProduct.sku,
            quantity: this.newProduct.quantity
          }
          this.output.products.push(obj)
          this.newProduct = {
            quantity: 0
          }
        } else {
          this.$vs.notify({
            color: 'warning',
            title: '¡Oh no!',
            text: 'Producto se encuentra agregado.'
          })
        }
      } else {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Selecciona producto e ingresa cantidad.'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1200px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
